import _ from 'lodash';
import {Directive, Module} from 'app/decorators';

@Module({
    name: "app.directives.blink",
})
@Directive('blink', function($timeout, $animate){
    "ngInject";
    return {
        link: function(scope, element, attrs) {
            let model = attrs.ngModel;
            element.addClass('blink');
            let watcher = scope.$watch(model, function(newV, oldV){
                let x = element;
                if (_.isUndefined(newV) || newV === oldV) { return; }
                if (document.activeElement == element[0]) { return; }
                $animate.addClass(element, 'blink-active');
                $timeout(function(){
                    $animate.removeClass(element, 'blink-active');
                }, 500);
            });

            scope.$on('$destroy', function () {
                watcher();
                watcher = null;
            })
        },
    };
})
export default class D {}



// WEBPACK FOOTER //
// ./src/app/directives/blink.js